import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge, taught about our own responsive type scale (`.type-name` /
 * `.type-body` / `.type-meta` / `.type-label`, defined in `styles/tailwind.css`).
 *
 * Without this it treats them as unknown classes and keeps BOTH `text-sm` and
 * `type-label` on an element — and because Tailwind emits the utilities layer
 * AFTER the components layer, the plain `text-sm` would silently win and the
 * scale would never apply. Registering them in the `font-size` group makes them
 * mutually exclusive with `text-*`, last one passed wins, as expected.
 */
const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			"font-size": ["type-name", "type-body", "type-meta", "type-label"],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
